import { Maybe } from 'maybe-not';

interface PendoWindow extends Window {
    pendo: any;
}

export default function createPendoTag(cdnOverride: Promise<Maybe<string>>) {
    if ((window as PendoWindow & typeof globalThis).pendo) {
        return;
    }

    cdnOverride.then(function(maybeCDN) {
        const pendoScript = document.createElement('script');
        pendoScript.async = true;
        pendoScript.src = `${maybeCDN.withDefault(
            'https://cdn1.onlineaccess1.com/cdn/'
        )}pendo/q2-pendo.js`;
        pendoScript.id = 'tecton-pendo-tag';
        document.querySelector('head')!.appendChild(pendoScript);
    });
}
